import { authAxios } from '@components/Auth';
import { snakes } from '@utils/lodash';
import { Claim } from '@models/Claim';
import { API_V1_BASE } from '@config';
import { paginate } from '@models/Pagination';
import { Pagination, PaginationParams } from '@models/Pagination';
import humps from 'lodash-humps-ts';

export type GetAllClaimParams = PaginationParams & {
  startDate?: string;
  endDate?: string;
  status?: string;
  billingType?: string;
  search?: string;
};

export type GetClaimParams = {
  claimableType: string;
  claimableId: number;
};
export type UploadClaimAdditionalDocumentsParams = GetClaimParams & {
  additionalDocuments: File[];
};
export type UpdateClaimParams = GetClaimParams & {
  status: string;
  note: string;
  totalClaimedAmount: number;
  approvedAmount?: number;
};

export class ClaimApi {
  static getAll = async (params = {} as GetAllClaimParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/claims`, { params: snakes(params) })
      .then((response) => paginate(response) as [Claim[], Pagination]);
  };

  static get = async ({ claimableType, claimableId }: GetClaimParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/claims/${claimableType}/${claimableId}`)
      .then((response) => humps(response.data) as Claim);
  };

  static uploadAdditionalDocuments = async ({
    claimableType,
    claimableId,
    additionalDocuments,
  }: UploadClaimAdditionalDocumentsParams) => {
    return await authAxios
      .putForm(`${API_V1_BASE}/user/claims/${claimableType}/${claimableId}/additional_documents`, {
        'additional_documents[]': additionalDocuments,
      })
      .then((response) => humps(response.data) as Claim);
  };

  static put = async ({ claimableType, claimableId, ...rest }: UpdateClaimParams) => {
    return await authAxios
      .put(`${API_V1_BASE}/user/claims/${claimableType}/${claimableId}`, snakes(rest))
      .then((response) => humps(response.data) as Claim);
  };
}
